import * as React from 'react'
import Dlg from './Dlg'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import ContentIcon from '../assets/images/content.svg'
import LocalIcon from '../assets/images/local.svg'
import WebsiteIcon from '../assets/images/service-website.svg'
import AdsIcon from '../assets/images/advertising.svg'
import DesignStudioIcon from '../assets/images/design_studio_icon.svg'
import { type IPrice } from '../redux/api/types'

import {
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
  Box,
  Typography
} from '@mui/material'
import { useTheme } from '@mui/material/styles'

interface BillingDlgProps {
  prices: IPrice[]
  productPrice: any
  open: any
  handleClose: any
  handleSubmit: any
  isSuccess: boolean
  isLoading: boolean
  category: any
}

const EditBillingDlg: React.FC<BillingDlgProps> = ({ prices, open, handleClose, handleSubmit, isLoading, category, productPrice }) => {
  const theme = useTheme()
  const [value, setValue] = React.useState(prices[0]?.interval)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value)
  }

  return (
    <Dlg name='Choose Your Billing' open={open} handleClose={handleClose} okBtnText={'Subscribe'} okDisabled={true} handleSubmit={handleSubmit} disabled={isLoading}>
      <FormControl sx={{ width: '100%', mb: 4 }}>
        <FormLabel
          id="billing-radio-buttons-label"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 500,
            lineHeight: '30px',
            fontSize: 18,
            mb: 4
          }}
          style={{ color: theme.palette.grey[70] }}
        >
            <>
                {
                    ((category?.category === 'local_presence') &&
                        <Box component='img' src={LocalIcon} sx={{ width: '35px', mr: 1 }} />) ||
                    ((category?.category === 'content') &&
                        <Box component='img' src={ContentIcon} sx={{ width: '35px', mr: 1 }} />) ||
                    ((category?.category === 'website') &&
                        <Box component='img' src={WebsiteIcon} sx={{ width: '35px', mr: 1 }} />) ||
                    ((category?.category === 'advertising') &&
                        <Box component='img' src={AdsIcon} sx={{ width: '35px', mr: 1 }} />) ||
                    ((category?.category === 'design_studio') &&
                        <Box component='img' src={DesignStudioIcon} sx={{ width: '35px', mr: 1 }} />)
                }
                <Typography sx={{ fontSize: '18px', fontWeight: 500, color: '#7D8FB3' }}>{productPrice.name}</Typography>
            </>
        </FormLabel>
        {prices.map(({ interval, monthlyAmount, annualSavings }, index) => {
          return (
            <RadioGroup key={index} sx={{ py: 1, px: 0, m: 0, fontWeight: 500 }}
              aria-labelledby="billing-radio-buttons-label"
              value={value}
              name="billing-radio-buttons"
              onChange={handleChange}
            >
              <Box
                sx= {{
                  color: theme.palette.grey[40],
                  height: '100%',
                  width: '100%',
                  border: value === interval ? '2px solid rgba(9, 181, 236, 1)' : '2px solid #B5B5B5',
                  borderRadius: '10px',
                  py: 1,
                  px: 3,
                  m: 0,
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center'
                }}
              >
                <FormControlLabel value={`${interval ?? ''}`}
                  control={<Radio
                    checkedIcon={<CheckCircleIcon />}
                    icon={<RadioButtonUncheckedIcon />}
                    sx={{
                      color: '#B5B5B5',
                      '&.Mui-checked': {
                        color: theme.palette.secondary.main
                      }
                    }}
                  />}
                  label={<Typography
                  variant='h4'
                  sx={{ fontWeight: 500, color: theme.palette.grey[40] }}
                >
                  {interval === 'year' ? 'Yearly' : 'Monthly'}
                </Typography>} />
                <Typography variant='body2' align='center'
                  sx={{
                    flexGrow: 1,
                    color: theme.palette.grey[40],
                    fontSize: 14,
                    mr: 1
                  }}
                >
                  {annualSavings ? `Annual Savings $${(annualSavings / 100).toFixed(2).toString()}` : ''}
                </Typography>
                <Typography variant='subtitle2'
                  sx={{
                    color: theme.palette.grey[40],
                    fontWeight: 500,
                    lineHeight: '30px'
                  }}
                >
                  ${((monthlyAmount ?? 0) / 100).toFixed(2).toString()}
                </Typography>
                <Typography variant='body2'
                  sx={{
                    color: '#ADB8CC',
                    fontWeight: 500,
                    fontSize: '12px',
                    lineHeight: '20px',
                    mt: '4px',
                    ml: '4px'
                  }}
                >
                  /month
                </Typography>
              </Box>
            </RadioGroup>
          )
        })}
      </FormControl>
    </Dlg>
  )
}

export default EditBillingDlg
